import React from 'react';
import HomeSingleFeature from '../../../components/HomeSingleFeature/HomeSingleFeature';
import { FiBook, FiLock} from 'react-icons/fi';
import { FaLightbulb, FaRibbon } from 'react-icons/fa';
import { BsHouseDoor } from 'react-icons/bs';
import { IoDocumentTextOutline } from 'react-icons/io5';

const HomeFeatures = () => {
   return (
      <>
         <section className="features__area pb-100 mt--100 wow fadeInUp" data-wow-delay=".5s">
            <div className="container">
               <div className="features__inner fix">
                  <div className="row g-0 ">

                     <HomeSingleFeature icon={<FaLightbulb />} title="Apoyo Psicológico" />
                     <HomeSingleFeature icon={< FiBook />} title="Asesoría Legal" />
                     <HomeSingleFeature icon={<BsHouseDoor />} title="Intervención Familiar" />
                     <HomeSingleFeature icon={<IoDocumentTextOutline />} title="Atención Médica" />
                     <HomeSingleFeature icon={<FiLock />} title="Compromiso Social" />
                     <HomeSingleFeature icon={<FaRibbon />} title="Seguimiento Personalizado" />

                  </div>
               </div>
            </div>
         </section>

      </>
   );
};

export default HomeFeatures;